import { getToken } from 'src/utils/helper';
import axios from '../../../utils/axios';
import { createSlice } from '@reduxjs/toolkit';
// https://apptest.arkchat.com/v1/admin/posts?page=1&pageSize=2
// API of userList
const POSTS_API = `${process.env.REACT_APP_BASE_URL}/posts`;

const initialState = {
  postsList: [],
  status: null,
  message: null,
};

export const PostsSlice = createSlice({
  name: 'PostsList',
  initialState,
  reducers: {
    postsListSuccess: (state, action) => {
      const newPosts = action.payload?.postsList?.result || [];
      const currentPosts = state.postsList?.result || [];
    
      // If it's the first page, replace the existing posts
      if (action.payload?.postsList?.page === 1) {
        state.postsList = {
          result: newPosts,
          total: action.payload?.postsList?.total,
          page: action.payload?.postsList?.page,
          pageSize: action.payload?.postsList?.pageSize,
        };
      } else {
        // For subsequent pages, append new posts to the existing list
        state.postsList = {
          result: [...currentPosts, ...newPosts],
          total: action.payload?.postsList?.total,
          page: action.payload?.postsList?.page,
          pageSize: action.payload?.postsList?.pageSize,
        };
      }
    
      state.status = action.payload.status;
      state.message = action.payload.message;
    },
    postsListFailure: (state, action) => {
      state.status = action.payload.status;
      state.message = action.payload.message;
    },
    removePost: (state, action) => {
      state.postsList.result = state.postsList.result.filter(
        (post) => post.id !== action.payload
      );
  
      state.postsList.total -= 1;
    },
    
    
  },
});

export const {
    postsListSuccess,
  postsListFailure,
  removePost
} = PostsSlice.actions;

//          https://apptest.arkchat.com/v1/admin/posts/29
// PATCH
// {
//     "reason": "Aise hi"
// } 

export const fetchPostsList = (postType, page, pageSize, search) => async (dispatch) => {
  let api_url = `${POSTS_API}?type=${postType}&page=${page}&pageSize=${pageSize}`;
  const token = getToken();

  if (search) {
    api_url = `${api_url}&search=${search}`;
  }

  try {
    const response = await axios.get(api_url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    await dispatch(
      postsListSuccess({
        status: response.data.status,
        message: response.data.message,
        postsList: response.data.data, // Pass the raw API response
      }),
    );

    return response?.data;
  } catch (error) {
    dispatch(
      postsListFailure({
        status: false,
        message: error.message,
      }),
    );
  }
};
export const deletePost = (post_id,body) => async (dispatch) => {
  let api_url = `${POSTS_API}/${post_id}`;
  const token = getToken();

  try {
    const response = await axios.patch(api_url, body, {
      headers: {
        // 'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.data.status) {
      dispatch(removePost(post_id));
      return response.data;
    } else {
      return response.data;
    }
  } catch (err) {
    throw new Error(err);
  }
};


export default PostsSlice.reducer;
